import React, { useState, useEffect, useCallback } from "react";
import { func, bool, array, string, number, object } from "prop-types";
import { Link, SocialShare, BREAKING_NEWS_UPDATED } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import CloseIcon from "../atoms/icons/close";
import ShareIcon from "../atoms/icons/Share";
import { staticTexts } from "../utils/Translate";
import ShareAllTemplate from "../molecules/ShareAllTemplate";
import { DfpComponent } from "../ads/dfp-component";
import ScrollSnap from "../atoms/ScrollSnap";
import RightArrowButton from "../atoms/icons/right-arrow-button";
import LeftArrowButton from "../atoms/icons/left-arrow-button";
import DfpContainer from "../ads/dfp-container";

import { setSocialShare } from "../helper/actions";
import { getBreakingNews } from "../helper/api";
import { DOMAIN_SLUG_NOT_BREAKING_NEWS, PAGE_TYPES_NOT_ADS, PREVIEW_PAGE_TYPES } from "../../constants";
import { checkRender, getSlotId, linkTarget } from "../utils/utils";

import "./breakingNewsSlider.m.css";

const BreakingNewsSliderView = ({
  lang,
  currentHostUrl,
  breakingNews = [],
  breakingNewsLoaded,
  pageType,
  updateInterval,
  breakingNewsUpdated,
  domainSlug,
  currentPath,
  headerSlug,
  story,
}) => {
  if (checkRender([...PAGE_TYPES_NOT_ADS, ...PREVIEW_PAGE_TYPES], pageType, ["trust"], domainSlug)) {
    return null;
  }

  const [isSocialShare, setIsSocialShare] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showBreakingNews, setShowBreakingNews] = useState(false);
  const [showAnchorAd, setShowAnchorAd] = useState(false);
  const [stopScroll, setStopScroll] = useState(false);
  const [slotId, setSlotId] = useState();

  const ads = {
    "home-page": {
      en: "EnPalo_HP_Floating_970x90",
      bn: "Mobile_HP_Anchor",
    },
    "section-page": {
      en: "EnPalo_Inner_Floating_970x90",
      bn: "Mobile_Article_Anchor",
    },
    "collection-page": {
      en: "EnPalo_Inner_Floating_970x90",
      bn: "Mobile_Article_Anchor",
    },
    "story-page": {
      en: "EnPalo_Inner_Floating_970x90",
      bn: "Mobile_Article_Anchor",
    },

    en: "EnPalo_Inner_Floating_970x90",
    bn: "Mobile_Article_Anchor",
  };

  const checkCacheIds = (stories = []) => {
    const cache = global.localStorage && global.localStorage.getItem("breakingIds");
    const storiesIds = stories.map(({ id }) => id).join();
    if (!cache || !storiesIds) return true;
    return storiesIds !== cache;
  };

  useEffect(() => {
    const slot = getSlotId("anchor-ad", currentPath, story?.id);
    setSlotId(slot);

    return () => {
      if (!PAGE_TYPES_NOT_ADS.includes(pageType) && story?.id) {
        window?.googletag?.cmd?.push(function () {
          window?.googletag?.destroySlots([slotId]);
        });
      }
    };
  }, [currentPath, story?.id]);

  const updateBreakingNews = () => {
    getBreakingNews().then((stories) => {
      const idCheck = checkCacheIds(stories);
      setShowBreakingNews(idCheck);
      if (idCheck) breakingNewsUpdated(stories);
    });
  };

  useEffect(() => {
    const show = !DOMAIN_SLUG_NOT_BREAKING_NEWS.includes(domainSlug);
    setShowBreakingNews(show);
    let interval;
    if (show) {
      global.setInterval(() => updateBreakingNews(), updateInterval || 60000);
      updateBreakingNews();
    }
    return () => show && interval && global.clearInterval(interval);
  }, []);

  const scrollCallback = useCallback(() => {
    if (window.scrollY >= 400 && !stopScroll) {
      setShowAnchorAd(true);
      setStopScroll(true);
    }
  });

  useEffect(() => {
    document.addEventListener("scroll", scrollCallback);

    return () => document.removeEventListener("scroll", scrollCallback);
  }, [scrollCallback]);

  const selectionChange = (index) => {
    setSelectedIndex(index);
  };

  // slider logics
  const processNewsElements = () => {
    return breakingNews.map((item, index) => {
      const linkedStorySlug = item?.metadata?.["linked-story-slug"];
      if (linkedStorySlug) {
        return (
          <div key={index} styleName="breaking-share-elements">
            <Link
              aria-label={item.headline || "breaking share elements"}
              styleName="link"
              href={`/${linkedStorySlug}`}
              target={linkTarget(currentHostUrl, item.url)}
            >
              {item.headline}
            </Link>
          </div>
        );
      }
      return (
        <div key={index} styleName="link breaking-share-elements">
          {item.headline}
        </div>
      );
    });
  };

  // ADS logic Start

  const bottomAdComponent = () => {
    if (slotId === undefined) return null;
    return (
      <DfpContainer>
        <div className="ad-bottom-container" styleName="ad-bottom show-ad">
          <div styleName="ad-bottom-wrapper">
            <div title="close" styleName="anchor-close" onClick={() => setShowAnchorAd(false)}>
              <CloseIcon />
            </div>
            <div styleName="ad-wrapper" className="adsBox">
              <DfpComponent targetStory={story} type={ads?.[pageType]?.[lang] || ads[lang]} slotId={slotId} />
            </div>
          </div>
        </div>
      </DfpContainer>
    );
  };

  const closeBreaking = () => {
    setShowBreakingNews(false);
    const breakingIds = breakingNews.map(({ id }) => id);
    if (localStorage && breakingIds.length > 0) {
      localStorage.setItem("breakingIds", breakingIds.join());
    }
  };

  const shareBreaking = () => {
    setIsSocialShare(!isSocialShare);
  };

  return showAnchorAd || (showBreakingNews && breakingNewsLoaded) ? (
    <div styleName="base">
      {showBreakingNews && breakingNewsLoaded && breakingNews.length > 0 && (
        <div styleName="breaking">
          <div styleName="breaking-icons">
            <div title="close" styleName="breaking-close" onClick={closeBreaking}>
              <CloseIcon />
            </div>
            {breakingNews[selectedIndex] &&
            breakingNews[selectedIndex].metadata &&
            breakingNews[selectedIndex].metadata["linked-story-slug"] ? (
              <div title="share" styleName="breaking-share" onClick={shareBreaking}>
                <ShareIcon />
              </div>
            ) : null}
          </div>
          <div styleName="breaking-wrapper">
            <div styleName="breaking-label">{staticTexts(lang).breakingNews}</div>
            <div styleName="breaking-share-elements">
              {isSocialShare &&
              breakingNews[selectedIndex] &&
              breakingNews[selectedIndex].metadata &&
              breakingNews[selectedIndex].metadata["linked-story-slug"] ? (
                <SocialShare
                  template={ShareAllTemplate}
                  title={breakingNews[selectedIndex].headline}
                  fullUrl={currentHostUrl + "/" + breakingNews[selectedIndex].metadata["linked-story-slug"]}
                  toggleShare={shareBreaking}
                  isBreakingNews={true}
                />
              ) : null}
              <ScrollSnap
                leftArrow={<LeftArrowButton />}
                rightArrow={<RightArrowButton />}
                isIndicator={breakingNews.length > 1 && true}
                isArrow={false}
                selectionChange={selectionChange}
                isInfinite={true}
                interval={10000}
                pauseOnHover={true}
                customStyle={true}
              >
                {processNewsElements()}
              </ScrollSnap>
            </div>
          </div>
        </div>
      )}
      {showAnchorAd && bottomAdComponent()}
    </div>
  ) : null;
};

BreakingNewsSliderView.propTypes = {
  breakingNews: array,
  lang: string,
  isSocialShare: bool,
  setSocialShare: func,
  currentHostUrl: string,
  isVerticalMenubar: bool,
  breakingNewsLoaded: bool,
  breakingNewsUpdated: func,
  pageType: string,
  updateInterval: number,
  domainSlug: string,
  headerSlug: string,
  currentPath: string,
  story: object,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  isSocialShare: get(state, ["socialShareReducer", "isSocialShare"], false),
  currentHostUrl: get(state, ["qt", "currentHostUrl"], []),
  breakingNews: get(state, ["breakingNews"], []),
  pageType: get(state, ["qt", "pageType"], ""),
  currentPath: get(state, ["qt", "currentPath"], ""),
  headerSlug: get(state, ["headerReducer", "showStoryHeader", "slug"]),
  breakingNewsLoaded: get(state, ["breakingNewsLoaded"], false),
  story: state?.story?.story || state?.qt?.data?.story,
});
const mapDispatchToProps = (dispatch) => ({
  setSocialShare: (flag) => dispatch(setSocialShare(flag)),
  breakingNewsUpdated: (stories) => dispatch({ type: BREAKING_NEWS_UPDATED, stories: stories }),
});

export default connect(mapStateToProps, mapDispatchToProps)(BreakingNewsSliderView);
